module.exports = __webpack_public_path__ + "static/media/mobile.a3148fc5.svg";